import { render } from "./BusinessesAdd.vue?vue&type=template&id=e9997b3e"
import script from "./BusinessesAdd.vue?vue&type=script&lang=js"
export * from "./BusinessesAdd.vue?vue&type=script&lang=js"
script.render = render

export default script